<mat-sidenav-container>
  <mat-sidenav #sidebar position="end">
    <mat-action-list>
      <div class="user-section">
        <img
          class="avatar"
          src="./assets/images/avatar.png"
          alt="User"
          height="250"
          width="250"
        />
        <div class="user-info">
          <p class="bold">{{ name() }}</p>
          @if (email(); as email) {
          <div>
            <p>{{ email }}</p>
          </div>
          }
        </div>
        <button mat-icon-button (click)="sidebar.close()">
          <mat-icon class="material-icons-outlined">close</mat-icon>
        </button>
      </div>
      @for ( item of navMenuItems().concat(dropdownItems()); track item; let i =
      $index; let last = $last) { @if (navMenuItems().length > 0 && (i ===
      navMenuItems().length || last)) {
      <mat-divider></mat-divider>
      }
      <button
        mat-list-item
        [id]="item.id || 'sidebar-' + i"
        (click)="onClick(item)"
      >
        <div matListItemTitle>
          @if (!last) {
          <mat-icon class="material-icons-outlined">{{ item.icon }}</mat-icon>
          }
          {{ item.labelKey | translate }}
        </div>
      </button>
      }
    </mat-action-list>
  </mat-sidenav>

  <mat-sidenav-content>
    <button
      mat-icon-button
      class="menu-button avatar"
      (click)="onMenuOpen()"
    ></button>
  </mat-sidenav-content>
</mat-sidenav-container>
